<template>
  <StudentParentManagement />
</template>

<script>
import StudentParentManagement from './StudentParent/Management.vue'

export default {
  name: 'ParentManage',
  components: { StudentParentManagement }
}
</script>
